import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Subject } from 'rxjs';
import { take, debounceTime } from 'rxjs/operators';
import swal from "sweetalert2";
import { HelperService } from '../../service/helper.service';
import { CustomerManageOrdersService } from '../../service/cutomer-manage-order.service';
import { EncryptionService } from '../../service/encryption.service';

@Component({
  selector: 'app-customer-selling-catalog',
  templateUrl: './customer-selling-catalog.component.html',
  styleUrls: ['./customer-selling-catalog.component.scss']
})
export class CustomerSellingCatalogComponent implements OnInit {

  ServiceCatalogList: any = new MatTableDataSource([]);
  page: any = 1;
  itemsPerPage: any = '10';
  totalItems: any = 0;
  limit: any = 10;
  search: any = '';
  sortBy: any = '';
  sortKey = '';
  sortClass: any = 'down';
  noRecordFound = false;
  filter: any;
  serviceIds = [];
  public requestPara = { search: '', page: 1, limit: 10, sortBy: '', sortKey: '' };
  RFQDisplayedColumns: string[] = ['codeId', 'sellingCatalogName','createdAt','Action'];
  private subject: Subject<string> = new Subject();
  sidebarMenuName: string;
  @ViewChild('table') table: MatTable<any>;
  servicePermission: any;
  loginUserId: any;
  constructor(public dialog: MatDialog,
    private ApiServices: CustomerManageOrdersService,
    private helper: HelperService,
    private translate: TranslateService,
    private route: ActivatedRoute,private encryptionService: EncryptionService,
    private router: Router) {
    this._setSearchSubscription();
  }

  ngOnInit(): void {
    const loginUser = this.encryptionService.getDataFromLocalStorage('NPLoginId');
    this.loginUserId = JSON.parse(loginUser);
    console.log('loginUserId', this.loginUserId)
    this.sideMenuName();
    // this.getSellingList(this.requestPara);
    this.ApiServices.paginationSelling.pipe(take(1)).subscribe(res => {
      this.pageChanged(res.page, res.limit.toString())
    })
  }

  sideMenuName() {
    this.sidebarMenuName = this.translate.instant('ORDERMANAGEMENT.SellingCatalogMenu');
    this.helper.sideMenuListName.next(this.sidebarMenuName);
  }


  viewDetails(event): void {
    this.router.navigate(['view-details/' + event.sellingCatalogId], { relativeTo: this.route });
  }

  redirectToOrder(event){
    localStorage.setItem('sellingCatalogId', JSON.stringify(event.sellingCatalogId))
    this.router.navigate(['customer-order/add-edit-order/']);
  }


  getSellingList(req: any): any {
    this.helper.toggleLoaderVisibility(true);
    this.requestPara["customerId"]= this.loginUserId;
    this.ApiServices.getSellingCatalogList(this.requestPara).subscribe((res: any) => {
      this.helper.toggleLoaderVisibility(false);
      if (res.result) {
        this.ServiceCatalogList = res?.data?.data?.length ? res.data.data : [];
        this.totalItems = res.data.totalcount;
        this.noRecordFound = this.ServiceCatalogList.length > 0;

      }
    }, (err: any) => {
      this.helper.toggleLoaderVisibility(false);
      swal.fire(
        '',
        this.translate.instant(err?.error?.message),
        'info'
      );
    });
  }




  onRefreshTable() {
    this.selection.clear();
    this.search = '';
    this.myInputVariable.nativeElement = '';
    this.pageChanged(1)
    document.body.classList.add('spin-animation');
    setTimeout(() => {
      document.body.classList.remove('spin-animation');
    }, 1000);
  }

  onKeyUp(searchTextValue: any): void {
    this.selection.clear();
    this.subject.next(searchTextValue);
  }

  // Pagination
  changeItemsPerPage(event): void {
    // this.search = '';
    this.selection.clear();
    this.page = 1;
    this.itemsPerPage = event
    console.log(this.itemsPerPage)
    this.getSellingList(this.requestPara = {
      page: 1, limit: this.itemsPerPage, search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey
    });
    this.limit = this.itemsPerPage;
  }

  pageChanged(page, limit?): void {
    // this.search = '';
    this.selection.clear();
    this.itemsPerPage = limit ? limit : this.itemsPerPage

    this.ApiServices.paginationSelling.next({
      page: page,
      limit: this.itemsPerPage,
      search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey
    })

    this.getSellingList(this.requestPara = {
      page, limit: this.itemsPerPage, search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey
    });
    this.page = page;
  }

  // Sorting
  changeSorting(sortKey, sortBy): void {
    // this.search = '';
    this.selection.clear();
    this.sortKey = sortKey;
    this.sortBy = (sortBy === '-1') ? '1' : '-1';
    this.page = 1;
    this.getSellingList(this.requestPara = {
      page: 1,
      limit: this.limit,
      search: this.search,
      sortBy: this.sortBy,
      sortKey: this.sortKey
    });
  }

  private _setSearchSubscription(): void {
    this.subject.pipe(
      debounceTime(500)
    ).subscribe((searchValue: string) => {
      this.selection.clear();
      this.page = 1;
      this.getSellingList(this.requestPara = {
        page: 1,
        limit: this.limit,
        search: this.search,
        sortBy: this.sortBy,
        sortKey: this.sortKey
      });
    });
  }

  // search reset
  @ViewChild('searchBox') myInputVariable: ElementRef;

  resetSearch(): void {
    this.selection.clear();
    this.search = '';
    this.myInputVariable.nativeElement.value = '';
    this.page = 1;
    this.getSellingList(this.requestPara = {
      page: 1,
      limit: this.limit,
      search: '',
      sortBy: this.sortBy,
      sortKey: this.sortKey
    });
  }

  edit(event): void {
    this.router.navigate(['add-edit-selling-catalog/' + event.sellingCatalogId], { relativeTo: this.route });

  }

  // multiple delete
  checkboxvalue: boolean = false;

  toggleAllSelection(checkboxvalue: any) {
    for (var i = 0; i < this.ServiceCatalogList.length; i++) {
      this.ServiceCatalogList[i].checked = checkboxvalue.checked;
      if (checkboxvalue.checked) {
        this.checkboxvalue = true;
      } else {
        this.checkboxvalue = false;
      }
    }
  }

  selection = new SelectionModel<any>(true, []);

  isAllSelected() {
    const numSelected = this.selection?.selected?.length;
    const numRows = this.ServiceCatalogList?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.ServiceCatalogList);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

}
